// extracted by mini-css-extract-plugin
export default {"LanguagesMenu":"LanguagesMenu_LanguagesMenu__hXtoE"};